import { render, staticRenderFns } from "./uploaded-documents.vue?vue&type=template&id=17c8e4e4"
import script from "./uploaded-documents.vue?vue&type=script&lang=js"
export * from "./uploaded-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports